import { toPairs } from 'lodash/fp';

/**
 * "features": {
      "myPersonalMagicalFeature": {
        "and": {"allowLocales": ["de", "es", "nl"], "afterTime": '12.12.2018'},
      }
    }
 */

export default (getChecker) => (featureName, checkers) => (locals) => {
  checkers = toPairs(checkers);

  return checkers.every(([checkerName, args]) =>
    getChecker(checkerName)(featureName, args)(locals),
  );
};
